<template>
    <el-dialog title="公司用户信息" style="text-align:center" :visible="visible" :show="show" width="75%"  @close="close" :close-on-click-modal="false">
        <el-container style="height: 500px; border: 1px solid #eee">
            <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
                <el-tree
                        class="filter-tree"
                        :data="companyTree"
                        :props="defaultProps"
                        default-expand-all
                        @node-click="handleNodeClick"
                        ref="tree">
                </el-tree>
            </el-aside>

            <el-container>
                <el-main>
                    <el-table :data="tableData">
                        <el-table-column  align="center"  type="index" label="序号"> </el-table-column>
                        <el-table-column  align="center"  prop="account" label="账号"> </el-table-column>
                        <el-table-column  align="center"  prop="fullName" label="姓名"> </el-table-column>
                        <el-table-column  align="center"  prop="islock" label="是否锁定">
                            <template slot-scope="scope">
                                <span v-if="scope.row.islock=='1'">正常</span>
                                <span v-if="scope.row.islock=='0'">锁定</span>
                            </template>
                        </el-table-column>
                        <el-table-column  align="center"  prop="status" label="状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status=='0'">锁定</span>
                                <span v-if="scope.row.status=='1'">正常</span>
                                <span v-if="scope.row.status=='-1'">删除</span>
                            </template>
                        </el-table-column>
                        <el-table-column  align="center"  prop="mobile" label="手机"> </el-table-column>
                        <el-table-column  align="center"  prop="gender" label="性别">
                            <template slot-scope="scope">
                                <span v-if="scope.row.sex=='1'">男</span>
                                <span v-if="scope.row.sex=='2'">女</span>
                            </template>
                        </el-table-column>
                        <el-table-column  align="center"  prop="departmentName" label="所在部门"> </el-table-column>
                    </el-table>
                </el-main>
            </el-container>
        </el-container>
    </el-dialog>
</template>
<script>
    export default{
        name:'commpanyUserList',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                }
            },
            rowData(){
                if (this.show){
                    this.initCompanyList();
                    this.getUserList(null);
                }
            },
        },
        data(){
            return {
                defaultProps: {
                    children: 'companyList',
                    label: 'name'
                },
                companyTree:[],
                tableData:[],
            };
        },
        methods:{
            handleNodeClick(data) {
               // console.log(data.id);
                this.getUserList(data.id);
            },
            initCompanyList(){
                this.$http({
                    url: "company/getTreeCompanyList",
                    method: "get",
                }).then(({data}) => {
                    if(data && data.code === 0){
                        this.companyTree = [];
                        this.companyTree.push(data.rootOrg);
                    }
                });
            },
            close(){
                this.tableData = [];
                this.$emit("listenToChildEvent",false);
            },
            getUserList(orgId){
                let commpanyId = this.$storage.get("companyId");
                let params = {"companyId":commpanyId,'sort':'id','page':1,'limit':30,'order':'desc','orgId':orgId};
                this.$http({
                    url: "users/selectUserPage",
                    method: "get",
                    params:params
                }).then(({data}) => {
                    if(data && data.code === 0){
                        this.tableData = data.data.list;
                    }
                });
            }

        }
    }
</script>